import Loader from 'components/atoms/Loader/Loader';
import Notification from 'components/atoms/Notification/Notification';
import { candidateEmail } from 'constants/candidateEmail';
import { useMyRolesQuery } from 'generated/graphql';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import RoleCardsList from './RoleCardsList/RoleCardsList';

const RoleCardsListContainer: FC = () => {
  const { t } = useTranslation();
  const { handleMsgType } = useNotification();

  const myRolesQueryResponse = useMyRolesQuery({
    onError: error => {
      handleMsgType({
        type: TNotification.error,
        message: error?.message,
      });
    },
    fetchPolicy: 'network-only',
  });

  if (myRolesQueryResponse.loading) {
    return <Loader isOverlay />;
  }

  if (myRolesQueryResponse.error) {
    return (
      <div className="RoleCardsListContainer__NotificationWrapper">
        <Notification
          notification={{
            icon: 'Warning',
            color: 'Purple',
            message: t('roles.unfortunatelyThereHasBeenProblemLoadingRoles', {
              candidateEmail,
            }),
          }}
        />
      </div>
    );
  }

  if (myRolesQueryResponse.data) {
    return <RoleCardsList roles={myRolesQueryResponse.data.myRoles} />;
  }

  return null;
};

export default RoleCardsListContainer;
